import _ from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";

const patientNamespace = { namespace: "patient" };

@Component({})
export default class References extends Vue {
  @Prop(String)
  part!: string;

  @Prop(String)
  category!: string;

  private get _references() {
    return this.$store.getters[`${patientNamespace.namespace}/references`];
  }

  get references() {
    return _.get(this._references, [this.category, this.part], []);
  }
}
